import Arrow from "@components/icons/Arrow";
import { onEnterDown } from "@components/utils/accessibilityHelpers";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
interface ICalendarInput {
  setShowCalendar: Dispatch<SetStateAction<boolean>>;
  inputDate: string;
  label: string;
  hasAsterisk?: boolean;
  isOnStickyRaQ?: boolean;
}

const CalendarInput = ({
  setShowCalendar,
  inputDate,
  label,
  hasAsterisk,
  isOnStickyRaQ,
}: ICalendarInput): JSX.Element => {
  const formContext = useFormContext();
  const error = formContext.formState.errors.datepicker;
  const [nightsLabel, setNightsLabel] = useState<string>("");

  useEffect(() => {
    if (inputDate) {
      const inputDateArr = inputDate.split("-");
      formContext.clearErrors("datepicker");
      formContext.setValue(
        "datepicker",
        `${inputDateArr[0]} - ${inputDateArr[1]}`
      );
      setNightsLabel(inputDateArr[2]);
    } else {
      formContext.setValue("datepicker", "");
      setNightsLabel("");
    }
  }, [inputDate]);

  return (
    <>
      <div
        className={`float-input-container flex justify-between rounded-full`}
        onClick={() => {
          setShowCalendar(true);
        }}
        tabIndex={0}
        onKeyDown={(e) => onEnterDown(e, () => setShowCalendar(true))}
      >
        <div className="flex">
          <input
            type="text"
            aria-label={label}
            className={`placeholder-darkgray
            ${error ? "error-field" : ""} ${isOnStickyRaQ ? "!bg-white" : ""}`}
            id="datepicker"
            autoComplete="off"
            readOnly
            placeholder={label + (hasAsterisk ? "*" : "")}
            {...formContext.register("datepicker")}
          />
          {nightsLabel && (
            <div className="ml-[16px] flex w-[140px] items-center justify-center rounded-full bg-white px-4 text-p14">
              {nightsLabel}
            </div>
          )}
        </div>
        <div
          className={`absolute ${
            nightsLabel ? "right-[130px]" : "right-[25px]"
          } top-[20px]`}
        >
          <Arrow color="lightblue" size="medium" thickness="bold" />
        </div>
        {inputDate && <label className="active-float-label">When</label>}
        {error && <span className="error-text">{error.message}</span>}
      </div>
    </>
  );
};

export default CalendarInput;
